export default __webpack_public_path__ + "static/reishihover-5e1008250c96a5f6ad2e4b288ed7a1bf.png";